module.exports = __webpack_public_path__ + "static/gnoll_witherling-c65c2572c283282276fd75245a905d0c.jpeg";